export enum ESystemeTraitementAir {
    FluxUnidirectionnel = 1,
    FluxNonUnidirectionnel
}